import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getUserAccountsByUids, UserAccounts } from "services";
import { useAccessToken } from "./useAccessToken";

const ACCOUNT_STALE_TIME = 1000 * 60 * 5;

const getUserAccountByUids = async (uids: string[], accessToken: string) => {
    const resp = await getUserAccountsByUids(uids, accessToken);
    return resp.data.accounts;
};

export const useAccounts = (uids?: string[], options?: UseQueryOptions<UserAccounts[]>) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["accounts", uids],
        queryFn: () =>
            getUserAccountByUids(
                uids!.filter(id => !!id),
                accessToken!
            ),
        staleTime: ACCOUNT_STALE_TIME,
        enabled: Boolean(accessToken) && Boolean(uids?.length),
        ...options,
    });
};

export const useAccount = (uid?: string, options?: UseQueryOptions<UserAccounts>) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["account", uid],
        queryFn: async () => {
            const accounts = await getUserAccountByUids([uid!], accessToken!);
            return accounts[0];
        },
        staleTime: ACCOUNT_STALE_TIME,
        enabled: Boolean(accessToken) && Boolean(uid),
        ...options,
    });
};
